<script type="text/javascript">
import $ from 'jquery'
export default {
  name: 'registerAccountActivate',
  mounted () {
    // 加载已有的信息
    const vm = this
    $.ajax({
      type: 'PATCH',
      url: '/v1/user/register/confirm',
      dataType: 'json',
      async: true,
      data: {
        token: this.$route.params.token
      },
      success: function (data) {
        if (data.code === 200) {
          vm.$message.success('恭喜您，账户已成功激活，请直接登录！')
          vm.$router.push('/user/login')
          // window.location.href = '/user/login'
        } else if (data.code === 200006) {
          vm.$message.success('该账户已经被激活，请直接登录！')
          vm.$router.push('/user/login')
        } else if (data.code === 404) {
          vm.$message.warning('未找到指定链接！')
          vm.$router.push('/user/login')
        } else if (data.code === 504) {
          // TODO: message中暂时不能添加html
          // vm.$message.error('该验证链接已经失效，请尝试<a style="color:blue" href="/user/register/resend">重新发送</a>激活邮件')
          vm.$message.error('该验证链接已经失效，请尝试重新发送激活邮件')
          vm.$router.push('/user/register/resend')
        }
      },
      error: function (XMLHttpRequest, textStatus, errorThrown) {
        if (textStatus === 'timeout') {
          vm.$message.error('响应超时，请稍后重试')
        } else if (errorThrown === 'Unauthorized') {
          vm.$message.error('未授权')
        } else {
          vm.$message.error('系统异常，请稍后重试')
        }
      }
    })
  }
}
</script>
